/**
 * Раскладка сравнения версий: два полотна превью рядом.
 *
 * Ширины нет ни одной фиксированной — колонки текучие, `minmax(0, 1fr)` не даёт длинному
 * слову внутри пузыря раздвинуть сетку. Пузырь сообщения и так упирается в 480px (.tg-bubble),
 * поэтому потолка у сетки не нужно: на широком экране полотна просто встают в свою
 * естественную ширину.
 *
 * Порог один — 1100px, тот же, на котором расходится пара «исходник + превью» в режиме
 * правки. Число посчитано, а не выбрано: при 1100px области поста достаётся 720px, значит
 * полотну — 328px, а пузырю внутри — 300px. Это нижняя граница, на которой пост ещё читается
 * абзацами, а не столбиком по два слова. Ниже полотна встают друг под друга: сперва «было»,
 * затем «стало», в порядке чтения. Сравнивать два нечитаемых пузыря хуже, чем пролистать.
 */

.wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

/* Строка «что стало с файлом» несёт имя PDF — до 128 знаков, нередко без пробелов. Она пункт
   строчного флекса `.val`, и без этих свойств её минимальная ширина — имя целиком: на 390px
   строка уезжала за край (та же правка, что у полосы «Файл», ревью 19.09.2026, ui-8). */
.docLine {
  min-width: 0;
  overflow-wrap: anywhere;
}

.canvases {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: start;
}

@media (max-width: 1099px) {
  .canvases {
    grid-template-columns: minmax(0, 1fr);
  }
}

.side {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.sideHead {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.entities {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.entRow {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  color: var(--ink-2);
}

.sign {
  font-family: var(--sans);
  font-size: 12px;
  font-weight: 700;
  flex: none;
  width: 12px;
  text-align: center;
}
.add {
  color: var(--green-ink);
}
.del {
  color: var(--red-ink);
}

.range {
  font-family: var(--sans);
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  color: var(--muted);
}

.url {
  font-family: var(--sans);
  font-size: 12px;
  color: var(--muted);
  overflow-wrap: anywhere;
}
